export function injectGtm(gtmId) {
	if (!gtmId || window.__resaGtmInjected) return;

	const id = gtmId.startsWith("GTM-") ? gtmId : `GTM-${gtmId}`;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

	const script = document.createElement("script");
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
	document.head.appendChild(script);

	window.__resaGtmInjected = true;
}
